import { API as e, Resource as t } from "@coveo/platform-client";
//#region src/resources/LogicalIndexesResource.ts
var n = class n extends t {
	static {
		this.baseUrl = `/rest/organizations/${e.orgPlaceholder}/logicalindexes`;
	}
	list() {
		return this.api.get(n.baseUrl);
	}
	create(e) {
		return this.api.post(this.buildPath(n.baseUrl), { name: e });
	}
	getReplicationLimits() {
		return this.api.get(this.buildPath(`${n.baseUrl}/replication/limits`));
	}
};
//#endregion
export { n as LogicalIndexesResource };

//# sourceMappingURL=LogicalIndexesResource.js.map